import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { cn } from "@omni/utils/styles";

import { FilterButton } from "@/components/PaintConfigurator/components/shared/filter/filterButton";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useProductsContext } from "../../../../context/products.context";

type Props = {
    className?: string;
};

const DeliveryFilter = ({ className }: Props) => {
    const { t } = useGranite();

    const { setSelectedDeliveryType, selectedDeliveryType } =
        useProductsContext();

    return (
        <div className={cn("tw:flex tw:flex-col tw:gap-2", className)}>
            <div className={cn("tw:font-bold")}>
                {t("paintConfigurator.deliveryType.label")}
            </div>
            <div className={cn("tw:flex tw:gap-2 tw:flex-wrap ")}>
                {[DeliveryType.HomeDelivery, DeliveryType.ClickAndCollect].map(
                    (method) => (
                        <FilterButton
                            isSelected={selectedDeliveryType === method}
                            label={t(
                                `paintConfigurator.deliveryType.${method}`
                            )}
                            key={method}
                            onClick={() => setSelectedDeliveryType(method)}
                        >
                            {t(`paintConfigurator.deliveryType.${method}`)}
                        </FilterButton>
                    )
                )}
            </div>
        </div>
    );
};

export { DeliveryFilter };
